"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function (o, m, k, k2) {
    if (k2 === undefined)
        k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
        desc = { enumerable: true, get: function () { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function (o, m, k, k2) {
    if (k2 === undefined)
        k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function (o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function (o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function (o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o)
                if (Object.prototype.hasOwnProperty.call(o, k))
                    ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule)
            return mod;
        var result = {};
        if (mod != null)
            for (var k = ownKeys(mod), i = 0; i < k.length; i++)
                if (k[i] !== "default")
                    __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.TaxonomyClassDropdown = void 0;
const react_1 = __importStar(require("react"));
const taxonomy_class_dropdown_styles_1 = require("./taxonomy-class-dropdown.styles");
const hooks_1 = require("../../../hooks");
const hooks_2 = require("../../hooks");
const selectors_1 = require("../../../store/selectors");
const TaxonomyClassDropdown = ({ className, clearOnBlur = false, onInputChange, product, }) => {
    const client = (0, hooks_1.useEnrichClient)();
    const taxonomyClasses = (0, selectors_1.useClassesSelector)();
    const isLoading = (0, selectors_1.useClassesIsLoadingSelector)();
    const loadRefinements = (0, hooks_2.useRefinements)();
    const [taxonomyClass, setTaxonomyClass] = (0, react_1.useState)(null);
    const options = (0, react_1.useMemo)(() => taxonomyClasses.v2TerminalIds.map((id) => ({ label: taxonomyClasses.byId[id].title, value: id })), [taxonomyClasses]);
    const handleChange = (_, option, _reason, _details) => {
        var _a;
        const selectedOption = Array.isArray(option) ? option[0] : option;
        const nextValue = typeof selectedOption === 'string'
            ? { label: selectedOption, value: selectedOption }
            : selectedOption;
        setTaxonomyClass(nextValue);
        if (product) {
            const classId = (_a = nextValue === null || nextValue === void 0 ? void 0 : nextValue.value) !== null && _a !== void 0 ? _a : null;
            void client.products.updateOne({ id: product.id, classId }).then(() => {
                void loadRefinements();
            });
        }
    };
    (0, react_1.useEffect)(() => {
        var _a;
        if (product === null || product === void 0 ? void 0 : product.classId) {
            setTaxonomyClass({ label: (_a = taxonomyClasses.byId[product.classId]) === null || _a === void 0 ? void 0 : _a.title, value: product.classId });
        }
        return () => setTaxonomyClass(null);
    }, [product === null || product === void 0 ? void 0 : product.classId, setTaxonomyClass, taxonomyClasses]);
    return (react_1.default.createElement(taxonomy_class_dropdown_styles_1.StyledAutocomplete, { clearOnBlur: clearOnBlur, openOnFocus: true, className: className, loading: isLoading, onChange: handleChange, onInputChange: onInputChange, options: options, value: taxonomyClass, size: "small" }));
};
exports.TaxonomyClassDropdown = TaxonomyClassDropdown;
exports.default = exports.TaxonomyClassDropdown;
